"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.83 7.153a3.7 3.7 0 0 1 3.7-3.7h6.94a3.7 3.7 0 0 1 3.7 3.7v5.694a3.7 3.7 0 0 1-3.7 3.7H6.53a3.7 3.7 0 0 1-3.7-3.7zm1.578-.892h11.183a2.3 2.3 0 0 0-2.12-1.408H6.529a2.3 2.3 0 0 0-2.12 1.408m11.363 1.4H4.229v5.186a2.3 2.3 0 0 0 2.3 2.3h6.942a2.3 2.3 0 0 0 2.3-2.3zm-5.167 1.266a.7.7 0 0 1 .533.834l-.834 3.786a.7.7 0 1 1-1.368-.301L9.77 9.46a.7.7 0 0 1 .834-.533m1.404 1.132a.7.7 0 0 1 .99.006l.935.946a.7.7 0 0 1 0 .985l-.935.946a.7.7 0 0 1-.996-.984l.45-.454-.45-.455a.7.7 0 0 1 .006-.99m-3.925.99a.7.7 0 0 0-.995-.984l-.936.946a.7.7 0 0 0 0 .985l.936.946a.7.7 0 0 0 .995-.984l-.449-.454z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=WebFileIcon20.js.map